// @flow
import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import MainMobileHeadContainer from 'containers/main/MainMobileHeadContainer';
import MainHeadContainer from 'containers/main/MainHeadContainer';
import MainMobileFooter from 'components/main/MainMobileFooter';
import WishTemplateContainer from 'containers/wish/WishTemplateContainer';
import UserTemplate from 'components/user/UserTemplate';
import PageTemplate from 'components/base/PageTemplate';

type Props = {};

class Wish extends Component<Props> {
  render() {
    return (
      <PageTemplate>
        <header>
          <MainHeadContainer />
          <MainMobileHeadContainer />
        </header>
        <UserTemplate>
          <Helmet>
            <title>찜 목록 | 캐시바이</title>
          </Helmet>
          <WishTemplateContainer />
        </UserTemplate>
        <MainMobileFooter />
      </PageTemplate>
    );
  }
}

export default Wish;



// WEBPACK FOOTER //
// ./src/pages/Wish.js